import columns from '../../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_MESSAGES.id,
    mainReportId: ReportDefinitions.PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_KEY_DETAILS.id,
    requestParams: {
      eventId: rowInfo.original.eventId, // eslint-disable-line
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Version', 'messageVersion'),
        new TextColumn('Keys', 'keys'),
        new TextColumn('Description', 'description'),
      ],
    },
  ];
};
